export class RandomHelper {
  public static getRandomArbitrary(min:number = 10000000, max:number = 99999999) {
      return Math.random() * (max - min) + min;
  }

}

